
import {Validatable} from "winfakt-vue-components/src/mixins/validatable";
import {User} from "@/models/user";
import {Company} from "@/models/company";
import {UserService} from "@/services/user-service";
import {CompanyService} from "@/services/company-service";

export default Validatable.extend({
	data() {
		return {
			foundUsers: [] as User[],
			company: new Company(),
			input: "",
			focused: false
		};
	},
	props: {
		value: Object as () => User,
		fancy: Boolean,
		label: [String, Object],
		clearOnEnter: Boolean,
	},
	watch: {
		async input(input: string) {
			if (input.match(/^\s*$/)) {
				this.foundUsers = [];
				return;
			}
			this.foundUsers = await UserService.searchByUserName(this.input);
		},
		value: {
			immediate: true,
			handler(contact?: User) {
				if (this.value) {
					this.input = this.company.name + (this.company.isDemo ? " [DEMO]" : "");
				} else {
					this.input = "";
				}
			}
		}
	},
	methods: {
		onBlur() {
			this.focused = false;
			this.foundUsers = [];
			if (this.value) {
				this.input = this.value.firstname + " " + this.value.lastname + " - " + this.company.name + (this.company.isDemo ? " [DEMO]" : "");
			}
			this.$emit("blur");
		},
		onFocus() {
			this.input = "";
			this.focused = true;
		},
		async selectUser(user: User) {
			this.company = await CompanyService.getCompany(user.companyId);
			user.company = this.company;
			this.$emit("input", user);
			if (this.clearOnEnter) {
				this.input = "";
			}
			this.blur();
		},
		focus() {
			(this.$refs.input as any).focus();
		},
		blur() {
			(this.$refs.input as any).blur();
		}
	}
});
